<template>
  <div>
    <div class="main-container head pa-3 pa-md-6">
      <h1>
        {{ $t("program_list.search_results") }} : {{ curriculums.length }}
        {{ $t("program_list.list") }}
      </h1>
    </div>
    <div
      class="main-container pa-3 pa-md-6"
      v-for="campus in campuses"
      :key="campus.campus_id"
    >
      <h1>{{ objectTranslator(campus, "NAME") }}</h1>
      <div class="remark" v-if="campus.campus_id === CAMPUS_CHUMPORN_ID">
        {{ $t("confirm_regis.remark") }}<br />
        {{ $t("confirm_regis.remark_payment_ch_1") }}<br />
        {{ $t("confirm_regis.remark_payment_ch_2") }}<br />
        {{ $t("confirm_regis.remark_payment_ch_3") }}<br />
      </div>
      <div class="remark" v-if="campus.campus_id === CAMPUS_BKK_ID">
        {{ $t("confirm_regis.remark") }}<br />
        {{ $t("confirm_regis.remark_payment_kmitl") }}<br />
      </div>

      <div>
        <v-pagination
          :total-visible="9"
          v-if="campus.campus_id === CAMPUS_BKK_ID"
          class="mt-4"
          v-model="current_page_bkk"
          :length="page_bkk_total"
          circle
        ></v-pagination>
        <v-pagination
          :total-visible="9"
          v-if="campus.campus_id === CAMPUS_CHUMPORN_ID"
          class="mt-4"
          v-model="current_page_ch"
          :length="page_ch_total"
          circle
        ></v-pagination>
      </div>

      <div
        v-if="
          (campus.campus_id === CAMPUS_BKK_ID &&
            curriculums_bkk_paginated.length === 0) ||
            (campus.campus_id === CAMPUS_CHUMPORN_ID &&
              curriculums_ch_paginated.length === 0)
        "
        class="d-flex align-center justify-center no-result mt-3"
      >
        {{ $t("program_list.no_result") }}
      </div>

      <v-card
        elevation="1"
        light
        class="mt-3"
        v-for="item in campus.campus_id === CAMPUS_BKK_ID
          ? curriculums_bkk_paginated
          : curriculums_ch_paginated"
        v-bind:key="item.CURRICULUM_ID"
      >
        <v-card-title>
          <h1>
            {{ $t("program_list.curriculum") }} :
            {{ objectTranslator(item, "CURRICULUM_SHORT_NAME") }}
            <span v-if="item.BRANCH_NAME_EN">
              <span class="deep-orange--text">|</span>
              {{ $t("program_list.branch") }} :
              {{ objectTranslator(item, "BRANCH_NAME") }}
            </span>
            <div v-if="item.LEVEL_ID !== '1'">
              {{ $t("program_list.study_plan") }} :
              {{ objectTranslator(item, "STUDY_PLAN_NAME") }}
              <span class="deep-orange--text">|</span>
              {{ $t("program_list.study_classes") }} :
              {{ objectTranslator(item, "STUDY_CLASSES_NAME") }}
              <span v-if="item.SPECIFIC_NATION_ID !== '0'">
                <span class="deep-orange--text">|</span>
                {{ $t("program_list.specific_nation") }} :
                {{ objectTranslator(item, "SPECIFIC_NATION_NAME") }}
              </span>
            </div>
          </h1>
        </v-card-title>
        <v-card-text>
          <v-chip color="orange darken-3" dark small class="mr-1 mb-1">{{
            item.SEMESTER + " / " + item.YEAR
          }}</v-chip>

          <v-chip color="red" dark small class="mr-1 mb-1">{{
            $t("program_list.round") +
              " " +
              item.ROUND_NUMBER +
              " - " +
              objectTranslator(item, "ROUND_NAME")
          }}</v-chip>

          <v-chip color="deep-purple" dark small class="mr-1 mb-1">{{
            $t("program_list.project") +
              " " +
              objectTranslator(item, "PROJECT_NAME")
          }}</v-chip>

          <h2 class="deep-orange--text">
            {{ objectTranslator(item, "FACULTY_PREFIX_NAME") }}
            {{ objectTranslator(item, "FACULTY_NAME") }}
          </h2>
          {{ $t("program_list.curriculum") }} :
          {{ item.CURRICULUM_SHORT_NAME_TH }} /
          {{ item.CURRICULUM_SHORT_NAME_EN }}
          <br />
          <span v-if="item.BRANCH_NAME_TH">
            {{ $t("program_list.branch") }} : {{ item.BRANCH_NAME_TH }} /
            {{ item.BRANCH_NAME_EN }}
          </span>
          <h4>
            {{ $t("program_list.open_date") }} :
            <span class="light-blue--text text--darken-4">
              {{ dateFromDBTranslatorFull(item.START_APPLICATION_DATE) }} -
              {{ dateFromDBTranslatorFull(item.END_APPLICATION_DATE) }}
            </span>
          </h4>
          <h2 v-if="item.REMARK">
            <span class="light-green--text text--accent-4"
              >*** {{ $t("program_list.remark") }} :
              {{ item.REMARK }}
            </span>
          </h2>
        </v-card-text>
        <v-card-actions class="d-flex flex-wrap">
          <v-btn
            color="blue white--text"
            large
            :block="$vuetify.breakpoint.xsOnly"
            elevation="0"
            @click="regis(item)"
            >{{ $t("program_list.register") }}</v-btn
          >

          <v-btn
            class="ml-0 ml-sm-2 mt-2 mt-sm-0"
            color="deep-purple darken-2 white--text"
            large
            :block="$vuetify.breakpoint.xsOnly"
            elevation="0"
            @click="open_url(item.URL)"
            :disabled="!(item.URL && item.URL.length > 0)"
          >
            <v-icon class="mr-1">mdi-link-variant</v-icon>
            {{ $t("program_list.announcement") }}
          </v-btn>

          <v-btn
            class="ml-0 ml-sm-2 mt-2 mt-sm-0"
            color="red darken-4 white--text"
            large
            :block="$vuetify.breakpoint.xsOnly"
            elevation="0"
            @click="project_open_pdf(item.PROJECT_ID)"
            :disabled="item.PROJECT_PDF_EXISTS !== '1'"
          >
            <v-icon class="mr-1">mdi-file-pdf-box-outline</v-icon>
            <span>
              {{ $t("program_list.additional_info") }}
            </span>
          </v-btn>

          <v-btn
            class="ml-0 ml-sm-2 mt-2 mt-sm-0"
            color="orange darken-4 white--text"
            large
            :block="$vuetify.breakpoint.xsOnly"
            elevation="0"
            @click="curriculum_open_pdf(item.CURRICULUM_ID)"
            :disabled="item.CURRICULUM_PDF_EXISTS !== '1'"
            v-if="item.LEVEL_ID !== '1'"
          >
            <v-icon class="mr-1">mdi-file-pdf-box-outline</v-icon>
            <span>
              {{ $t("program_list.additional_info_graduate") }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <div>
        <v-pagination
          :total-visible="9"
          v-if="campus.campus_id === CAMPUS_BKK_ID"
          class="mt-4"
          v-model="current_page_bkk"
          :length="page_bkk_total"
          circle
        ></v-pagination>
        <v-pagination
          :total-visible="9"
          v-if="campus.campus_id === CAMPUS_CHUMPORN_ID"
          class="mt-4"
          v-model="current_page_ch"
          :length="page_ch_total"
          circle
        ></v-pagination>
      </div>

      <v-divider
        class="mt-6"
        v-if="campus.campus_id === CAMPUS_BKK_ID"
      ></v-divider>
    </div>
  </div>
</template>

<script>
import {
  objectTranslator,
  dateFromDBTranslatorFull,
} from "@/helper/translator";
import { absoluteUrl } from "@/helper/string";
import { createHelpers } from "vuex-map-fields";
import ConfigProvider from "@/services/config.provider";

const configService = new ConfigProvider();

const { mapFields: paramsFields } = createHelpers({
  getterType: "params/getField",
  mutationType: "params/updateField",
});

const CAMPUS_BKK_ID = "BKK";
const CAMPUS_CHUMPORN_ID = "CHUMPORN";

const curr_per_page = 5;

export default {
  props: {
    curriculums: Array,
    open_confirm_regis_dialog: Function,
  },
  data: () => ({
    CAMPUS_BKK_ID,
    CAMPUS_CHUMPORN_ID,
    campuses: [
      { NAME_EN: "Bangkok", NAME_TH: "กทม.", campus_id: CAMPUS_BKK_ID },
      { NAME_EN: "Chumporn", NAME_TH: "ชุมพร", campus_id: CAMPUS_CHUMPORN_ID },
    ],
    current_page_bkk: 1,
    current_page_ch: 1,
  }),
  computed: {
    curriculums_bkk() {
      return this.curriculums.filter(
        (item) => item.MASTER_REG_FACULTY_ID !== "20"
      );
    },

    curriculums_ch() {
      return this.curriculums.filter(
        (item) => item.MASTER_REG_FACULTY_ID === "20"
      );
    },

    page_bkk_total() {
      return Math.ceil(this.curriculums_bkk.length / curr_per_page);
    },

    page_ch_total() {
      return Math.ceil(this.curriculums_ch.length / curr_per_page);
    },

    curriculums_bkk_paginated() {
      return this.curriculums_bkk.filter((item, index) => {
        return (
          index >= (this.current_page_bkk - 1) * curr_per_page &&
          index < this.current_page_bkk * curr_per_page
        );
      });
    },

    curriculums_ch_paginated() {
      return this.curriculums_ch.filter((item, index) => {
        return (
          index >= (this.current_page_ch - 1) * curr_per_page &&
          index < this.current_page_ch * curr_per_page
        );
      });
    },

    isApplicantLoggedIn() {
      return (
        this.$store.state.auth.user &&
        this.$store.state.auth.user.admission.status
      );
    },
    ...paramsFields({
      open_login_dialog: "open_login_dialog",
    }),
  },
  methods: {
    objectTranslator,
    dateFromDBTranslatorFull,

    // curriculums_by_campus(campus_id) {
    //   if (campus_id === CAMPUS_BKK_ID) {
    //     return this.curriculums.filter(
    //       (item) => item.MASTER_REG_FACULTY_ID !== "20"
    //     );
    //   } else {
    //     return this.curriculums.filter(
    //       (item) => item.MASTER_REG_FACULTY_ID === "20"
    //     );
    //   }
    // },

    reset_pagination() {
      this.current_page_bkk = 1;
      this.current_page_ch = 1;
    },

    async regis(curriculum_object) {
      if (!this.isApplicantLoggedIn) {
        this.open_login_dialog = true;
      } else {
        this.open_confirm_regis_dialog(curriculum_object);
      }
    },

    open_url(url) {
      if (url && url.length > 0) {
        window.open(absoluteUrl(url), "_blank");
      }
    },

    // open_pdf(project_id) {
    //   const url =
    //     process.env.VUE_APP_ENDPOINT +
    //     "admission/api/" +
    //     "?function=get-document-file&service_type=config-project&" +
    //     "response_type=file&PROJECT_ID=" +
    //     project_id;
    //   window.open(url, "_blank");
    // },

    async project_open_pdf(project_id) {
      this.loading = true;
      const response = await configService
        .getProjectFile({
          PROJECT_ID: project_id,
        })
        .catch((error) => {
          this.loading = false;
          error.response.data.text().then((text) => {
            this.$toasted.error(JSON.stringify(text), {
              duration: 0,
            });
          });
        });
      if (response) {
        const fileUrl = window.URL.createObjectURL(response);

        // Create a temporary link and trigger the download
        const link = document.createElement("a");
        link.href = fileUrl;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();

        // Clean up
        window.URL.revokeObjectURL(fileUrl);
        document.body.removeChild(link);

        this.loading = false;
      }
    },

    async curriculum_open_pdf(curriculum_id) {
      this.loading = true;
      const response = await configService
        .getCurriculumFile({
          CURRICULUM_ID: curriculum_id,
        })
        .catch((error) => {
          this.loading = false;
          error.response.data.text().then((text) => {
            this.$toasted.error(JSON.stringify(text), {
              duration: 0,
            });
          });
        });
      if (response) {
        const fileUrl = window.URL.createObjectURL(response);

        // Create a temporary link and trigger the download
        const link = document.createElement("a");
        link.href = fileUrl;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();

        // Clean up
        window.URL.revokeObjectURL(fileUrl);
        document.body.removeChild(link);

        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  background-color: #fffa;
}

.main-container .head {
  background-color: white;
}

.remark {
  color: red;
}

.no-result {
  color: grey;
}
</style>
